
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.441 17.017H5.174c-2.633 0-3.508-1.75-3.508-3.509V6.492c0-2.634.875-3.509 3.508-3.509h5.267c2.633 0 3.508.875 3.508 3.509v7.016c0 2.634-.883 3.509-3.508 3.509z","stroke":"#B5B8B5","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.266 14.25l-2.317-1.625V7.367l2.317-1.625c1.133-.792 2.067-.309 2.067 1.083v6.35c0 1.392-.934 1.875-2.067 1.075zM9.584 9.167a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z","stroke":"#B5B8B5","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    